var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        [
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !this.loading,
                  expression: "!this.loading"
                }
              ]
            },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    { staticClass: "mb-1", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-header",
                        {
                          staticClass: "p-1",
                          attrs: { "header-tag": "header", role: "tab" }
                        },
                        [
                          _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.accordion1",
                                  modifiers: { accordion1: true }
                                }
                              ],
                              attrs: {
                                block: "",
                                href: "#",
                                variant: "primary"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Search Criteria\n            "
                              ),
                              !_vm.showCriteria
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "caret-down", size: "lg" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showCriteria
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "caret-up", size: "lg" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            id: "accordion1",
                            visible: "",
                            accordion: "accordion1",
                            role: "tabpanel"
                          },
                          model: {
                            value: _vm.showCriteria,
                            callback: function($$v) {
                              _vm.showCriteria = $$v
                            },
                            expression: "showCriteria"
                          }
                        },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c(
                                "b-container",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c("h3", [_vm._v("Compare")]),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Programme(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options:
                                                        _vm.programmeList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      "track-by": "id",
                                                      label: "name",
                                                      placeholder: "All"
                                                    },
                                                    model: {
                                                      value: _vm.programmes1,
                                                      callback: function($$v) {
                                                        _vm.programmes1 = $$v
                                                      },
                                                      expression: "programmes1"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Year(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.yearsList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder: "All"
                                                    },
                                                    model: {
                                                      value: _vm.years1,
                                                      callback: function($$v) {
                                                        _vm.years1 = $$v
                                                      },
                                                      expression: "years1"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Industry(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.industryList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder: "All",
                                                      "select-label": "",
                                                      "deselect-label": ""
                                                    },
                                                    model: {
                                                      value: _vm.industries1,
                                                      callback: function($$v) {
                                                        _vm.industries1 = $$v
                                                      },
                                                      expression: "industries1"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Customer(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.customerList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      "track-by": "id",
                                                      label: "name",
                                                      placeholder: "All"
                                                    },
                                                    model: {
                                                      value: _vm.customers1,
                                                      callback: function($$v) {
                                                        _vm.customers1 = $$v
                                                      },
                                                      expression: "customers1"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Country(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.countryList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder: "All"
                                                    },
                                                    model: {
                                                      value: _vm.countries1,
                                                      callback: function($$v) {
                                                        _vm.countries1 = $$v
                                                      },
                                                      expression: "countries1"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Region(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.regionList1,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder: "All",
                                                      "group-values": "regions",
                                                      "group-label": "country",
                                                      "group-select": true
                                                    },
                                                    model: {
                                                      value: _vm.regions1,
                                                      callback: function($$v) {
                                                        _vm.regions1 = $$v
                                                      },
                                                      expression: "regions1"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Labelled As")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: "Dataset 1"
                                                    },
                                                    model: {
                                                      value: _vm.label1,
                                                      callback: function($$v) {
                                                        _vm.label1 = $$v
                                                      },
                                                      expression: "label1"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c("h3", [_vm._v("With")]),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Programme(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options:
                                                        _vm.programmeList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      "track-by": "id",
                                                      label: "name",
                                                      placeholder: "All"
                                                    },
                                                    model: {
                                                      value: _vm.programmes2,
                                                      callback: function($$v) {
                                                        _vm.programmes2 = $$v
                                                      },
                                                      expression: "programmes2"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Year(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.yearsList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder: "All"
                                                    },
                                                    model: {
                                                      value: _vm.years2,
                                                      callback: function($$v) {
                                                        _vm.years2 = $$v
                                                      },
                                                      expression: "years2"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Industry(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.industryList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder: "All",
                                                      "select-label": "",
                                                      "deselect-label": ""
                                                    },
                                                    model: {
                                                      value: _vm.industries2,
                                                      callback: function($$v) {
                                                        _vm.industries2 = $$v
                                                      },
                                                      expression: "industries2"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Customer(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.customerList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      "track-by": "id",
                                                      label: "name",
                                                      placeholder: "All"
                                                    },
                                                    model: {
                                                      value: _vm.customers2,
                                                      callback: function($$v) {
                                                        _vm.customers2 = $$v
                                                      },
                                                      expression: "customers2"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Country(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.countryList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder: "All"
                                                    },
                                                    model: {
                                                      value: _vm.countries2,
                                                      callback: function($$v) {
                                                        _vm.countries2 = $$v
                                                      },
                                                      expression: "countries2"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Region(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.regionList2,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder: "All",
                                                      "group-values": "regions",
                                                      "group-label": "country",
                                                      "group-select": true
                                                    },
                                                    model: {
                                                      value: _vm.regions2,
                                                      callback: function($$v) {
                                                        _vm.regions2 = $$v
                                                      },
                                                      expression: "regions2"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Labelled As")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: "Dataset 2"
                                                    },
                                                    model: {
                                                      value: _vm.label2,
                                                      callback: function($$v) {
                                                        _vm.label2 = $$v
                                                      },
                                                      expression: "label2"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !this.loading,
                  expression: "!this.loading"
                }
              ],
              staticClass: "pt-3"
            },
            [
              _c(
                "b-col",
                { staticClass: "text-left align-left" },
                [
                  _c("toggle-button", {
                    attrs: {
                      id: "gears-or-scores",
                      labels: { checked: "Gears", unchecked: "Average Scores" },
                      width: 200,
                      height: 40,
                      "switch-color": {
                        checked: "#0069D9",
                        unchecked: "#218838"
                      },
                      color: { checked: "#278fff", unchecked: "#30c651" }
                    },
                    model: {
                      value: _vm.showGears,
                      callback: function($$v) {
                        _vm.showGears = $$v
                      },
                      expression: "showGears"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right align-right" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          _vm.calculateData()
                        }
                      }
                    },
                    [_vm._v("Compare")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chartData && !_vm.loadingData,
                  expression: "chartData && !loadingData"
                }
              ],
              staticClass: "pt-4 pb-4"
            },
            [
              _c(
                "b-col",
                { staticClass: "text-center align-center mx-auto" },
                [
                  _vm.chartData
                    ? _c("score-gear-year-line", {
                        attrs: {
                          "chart-data": _vm.chartData,
                          width: 1000,
                          "show-gears": _vm.showGears,
                          label1: _vm.label1,
                          label2: _vm.label2
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "text-center align-center",
              attrs: { "align-h": "center" }
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "spinner", size: "lg", spin: "" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loadingData,
                  expression: "loadingData"
                }
              ],
              staticClass: "text-center align-center mx-auto",
              attrs: { "align-h": "center" }
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "spinner", size: "lg", spin: "" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79331428", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79331428","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndustryScoreGearLines.vue
// module id = null
// module chunks = 